import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { Container } from 'reactstrap';
import {
    AppFooter,
    AppHeader,
    AppSidebar,
    AppSidebarHeader,
    AppSidebarNav
} from '@coreui/react';
import Footer from './Footer';
import Header from './Header';
import routes from '../config/routes';
// import { APP_ID } from '../config/globals';
import navigation from '../config/navigation';

const ADMIN_ONLY_NAV = ['Category', 'Analytics'];

const RoleRoute = ({ component: Component, roles, ...rest }) => {
    const auth = JSON.parse(localStorage.getItem('auth'));
    const userRole = auth?.role;
    return (
        <Route {...rest} render={props =>
            !roles || roles.includes(userRole)
                ? <Component {...props} />
                : <Redirect to="/dashboard" />
        } />
    );
};

class Home extends Component {
    render() {
        const auth = JSON.parse(localStorage.getItem('auth'));
        const isAdmin = auth?.role === 'ADMIN';
        const filteredNavigation = {
            ...navigation,
            items: isAdmin
                ? navigation.items
                : navigation.items.filter(item => !ADMIN_ONLY_NAV.includes(item.name)),
        };

        return (
            <div className="app">
                <AppHeader fixed>
                    <Header />
                </AppHeader>
                <div className="app-body">
                    <AppSidebar fixed display="lg">
                        <AppSidebarHeader />
                        <AppSidebarNav navConfig={filteredNavigation} {...this.props} />
                    </AppSidebar>
                    <main className="main">
                        <Container fluid className="px-0">
                            <Switch>
                                {routes.map((route, idx) => {
                                    return route.component ? (
                                        route.roles
                                            ? <RoleRoute key={idx} path={route.path} exact={route.exact} name={route.name} component={route.component} roles={route.roles} />
                                            : <Route key={idx} path={route.path} exact={route.exact} name={route.name} render={props => <route.component {...props} />} />
                                    ) : null;
                                })}
                                <Redirect from="/" to={`/dashboard`} />
                            </Switch>
                        </Container>
                    </main>
                </div>
                <AppFooter>
                    <Footer />
                </AppFooter>
            </div>
        );
    }
}

export default Home;
